import { useParams, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import Moment from "moment";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  PageSettingsModel,
  Sort,
  Inject,
} from "@syncfusion/ej2-react-grids";
import Icon from "../Icon/Icon";
import iconConsultas      from "../../../img/icons/svg/historial/historial-card-01.svg";
import iconRehab          from "../../../img/icons/svg/historial/historial-card-02.svg";
import iconQuirofano      from "../../../img/icons/svg/historial/historial-card-03.svg";
import iconHospitalizacion from "../../../img/icons/svg/historial/historial-card-04.svg";
import iconUrgencias      from "../../../img/icons/svg/historial/ambulance.png";
import iconImagen         from "../../../img/icons/record/grisMedium.png";
import "./grids.scss";
import "./Cards.scss";
interface IRecordDetailVisitGrid {
  arrData: any[] | undefined;
  type_id: number;
  recordType: string;
  contingencyType: number;
}

const RecordDetailVisitGrid: React.FC<IRecordDetailVisitGrid> = ({
  arrData,
  type_id,
  recordType,
  contingencyType,
}) => {
  const navigate = useNavigate();
  const { id: paramsId } = useParams<{ id: string }>();
  const arrParamsId = paramsId.split("_");
  const recordId = arrParamsId[1]
  const typeRecordDetailVisitGridRrow: string =
    recordType === "1"
      ? "row-bright"
      : recordType === "2 "
        ? "row-dark"
        : recordType === "3"
          ? "row-clear"
          : "azul";
  const [pageOptions2] = useState<PageSettingsModel>({
    pageSize: 3,
    pageSizes: ["3", "10", "15", "20", "Todos"],
  });

  const [pageOptions] = useState<PageSettingsModel>({
    pageSize: 10,
    pageSizes: ["5", "10", "15", "20", "Todos"],
  });
  const [sortingOptions] = useState<Object>({
    columns: [{ field: "FechaHoraInicio", direction: "Descending" }],
  });
  const [sortingOptions2] = useState<Object>({
    columns: [{ field: "fechaHoraFinSesion", direction: "Descending" }],
  });

  const estadoValue = function (field: any, data: any, column: any) {

    return (data[field] === 0) ? "Realizada" : "Cancelada";

  }

  const rowSelected = (args: any) => {
    if (args != null) {
      let idRow = args.data.id;
      let eventTypeRow = type_id;
      let redirectPath = `/historial/${recordType}_${recordId}_${contingencyType}/informacion-asistencial/${eventTypeRow}/${idRow}`;
      navigate(redirectPath, {
        state: {
          origin: "historial",
          contingencyType: contingencyType,
        }
      });
    }
  };
  const rowSelectedReha = (args: any) => {
    if (args != null) {
      let idRow = args.data.id;
      let episodeId = args.data.episodioId
      let idSesion = args.data.id
      let eventTypeRow = type_id;
      let redirectPath = `/historial/${recordType}_${recordId}_${contingencyType}/informacion-asistencial/${eventTypeRow}/${idSesion}`;
      navigate(redirectPath, {
        state: {
          origin: "historial",
          contingencyType: contingencyType,
          idSesion: idSesion,
          episodeId: episodeId
        }
      });
    }
  };
  const customAttributes = { class: 'customcss' };
  // URGENCIAS
  if (type_id === 206) {
    return (
      <div className={`${typeRecordDetailVisitGridRrow} record-detail-visit-grid_row`}>
        <div className="cards-list">
          {arrData.map((item: any) => (
            <article key={item.id} className="item-card item-card--compact">
              <div className="item-card__icon" style={{ background: '#0650b0' }}>
                <img src={iconUrgencias} alt="Urgencias" style={{ width: 22, height: 22, objectFit: "contain" }} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{item.servicioDescripcion}</div>
                <div className="item-card__meta">
                  {item.especialidad && <span className="item-card__sub">{item.especialidad}</span>}
                  {item.FechaHoraInicio && (
                    <span className="item-card__sub">
                      {Moment(item.FechaHoraInicio).format("DD/MM/YYYY HH:mm")}
                    </span>
                  )}
                  {item.nombreFacultativo && <span className="item-card__sub">{item.nombreFacultativo}</span>}
                  {item.centro?.descripcion && <span className="item-card__sub">{item.centro.descripcion}</span>}
                </div>
              </div>
              <div className="item-card__action">
                <button className="item-card__download-btn" onClick={() => rowSelected({ data: item })}>
                  <Icon name="eye" size={14} />
                  Ver
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
  }
  // CONSULTAS
  if (type_id === 200) {
    return (
      <div className={`${typeRecordDetailVisitGridRrow}`}>
        <div className="cards-list">
          {arrData.map((item: any) => (
            <article key={item.id} className="item-card item-card--compact">
              <div className="item-card__icon" style={{ background: '#06b6bb' }}>
                <img src={iconConsultas} alt="consultas" style={{ width: 22, height: 22, objectFit: "contain" }} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{item.especialidad}</div>
                <div className="item-card__meta">
                  {item.FechaHoraInicio && (
                    <span className="item-card__sub">
                      {Moment(item.FechaHoraInicio).format("DD/MM/YYYY HH:mm")}
                    </span>
                  )}
                  {item.nombreFacultativo && <span className="item-card__sub">{item.nombreFacultativo}</span>}
                  {item.centro?.descripcion && <span className="item-card__sub">{item.centro.descripcion}</span>}
                </div>
              </div>
              <div className="item-card__action">
                <button className="item-card__download-btn" onClick={() => rowSelected({ data: item })}>
                  <Icon name="eye" size={14} />
                  Ver
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
  }
  // REHABILITACION
  if (type_id === 205 && arrData.length > 0) {
    let count = 1
    const datae = arrData.map((item, i) => (
      <div key={i} className='episode-rehab'>

        <h4 className="title-epidode-reha">Episodio Rehabilitación {count + i}</h4>
        <div className={`${typeRecordDetailVisitGridRrow}`} key={i}>
          <GridComponent
            dataSource={[item]}
            allowSorting={false}

          >
            <ColumnsDirective>

              <ColumnDirective
                field="numeroSesionesSolicitadas"
                headerText="Sesiones Solicitadas"
                width="70"
                customAttributes={customAttributes}
              />
              <ColumnDirective
                field="numeroSesionesRealizadas"
                headerText="Sesiones Finalizadas"
                width="70"
                customAttributes={customAttributes}
              />

              <ColumnDirective
                field="FechaHoraInicio"
                headerText="Fecha y Hora"
                type="date"
                format="dd/MM/yyyy HH:mm"
                width="100"
                customAttributes={customAttributes}
              />
            </ColumnsDirective>
            <Inject services={[Page, Sort]} />
          </GridComponent>
        </div>
        <br />
        <div className={`${typeRecordDetailVisitGridRrow}`}>
          <GridComponent
            dataSource={item.Sesiones}
            allowPaging={true}
            allowSorting={false}
            rowSelected={rowSelectedReha}
            pageSettings={pageOptions2}
            sortSettings={sortingOptions2}
            key={i}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="numeroSerie"
                headerText="Nº Serie"
                width="70"
              />

              <ColumnDirective
                field="estado"
                headerText="Estado"
                width="100"
                valueAccessor={estadoValue}
              />

              <ColumnDirective
                field="fechaHoraInicioSesion"
                headerText="Fecha y Hora"
                type="date"
                format="dd/MM/yyyy HH:mm"
                width="100"
              />
              <ColumnDirective
                field="nombreAsistencial"
                headerText="Profesional"
                width="100"
              />
              <ColumnDirective
                field="centro.descripcion"
                headerText="Centro"
                width="100"
              />
              <ColumnDirective
                field="observaciones"
                headerText="Comentarios"
                width="100"
              />
            </ColumnsDirective>
            <Inject services={[Page, Sort]} />
          </GridComponent>
        </div>

      </div>
    ));
    return (<>{datae}</>)
  }


  // QUIROFANO
  if (type_id === 204) {
    return (
      <div className={`${typeRecordDetailVisitGridRrow}`}>
        <div className="cards-list">
          {arrData.map((item: any) => (
            <article key={item.id} className="item-card item-card--compact">
              <div className="item-card__icon" style={{ background: '#0F1F3D' }}>
                <img src={iconQuirofano} alt="quirófano" style={{ width: 22, height: 22, objectFit: "contain" }} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{item.especialidad}</div>
                <div className="item-card__meta">
                  {item.FechaHoraInicio && (
                    <span className="item-card__sub">
                      {Moment(item.FechaHoraInicio).format("DD/MM/YYYY HH:mm")}
                    </span>
                  )}
                  {item.cirujano && <span className="item-card__sub">{item.cirujano}</span>}
                  {item.centro?.descripcion && <span className="item-card__sub">{item.centro.descripcion}</span>}
                </div>
              </div>
              <div className="item-card__action">
                <button className="item-card__download-btn" onClick={() => rowSelected({ data: item })}>
                  <Icon name="eye" size={14} />
                  Ver
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
  }
  // HOSPITALIZACION
  if (type_id === 202) {
    return (
      <div className={`${typeRecordDetailVisitGridRrow} record-detail-visit-grid_row`}>
        <div className="cards-list">
          {arrData.map((item: any) => (
            <article key={item.id} className="item-card item-card--compact">
              <div className="item-card__icon" style={{ background: '#407ece' }}>
                <img src={iconHospitalizacion} alt="hospitalización" style={{ width: 22, height: 22, objectFit: "contain" }} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{item.especialidad}</div>
                <div className="item-card__meta">
                  {item.diasEstancia != null && (
                    <span className="item-card__sub">{item.diasEstancia} días de estancia</span>
                  )}
                  {item.FechaHoraInicio && (
                    <span className="item-card__sub">
                      {Moment(item.FechaHoraInicio).format("DD/MM/YYYY HH:mm")}
                    </span>
                  )}
                  {item.medicoResponsable && <span className="item-card__sub">{item.medicoResponsable}</span>}
                  {item.centro?.descripcion && <span className="item-card__sub">{item.centro.descripcion}</span>}
                </div>
              </div>
              <div className="item-card__action">
                <button className="item-card__download-btn" onClick={() => rowSelected({ data: item })}>
                  <Icon name="eye" size={14} />
                  Ver
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
  }
  // IMAGEN
  if (type_id === 203) {
    return (
      <div className={`${typeRecordDetailVisitGridRrow} record-detail-visit-grid_row`}>
        <div className="cards-list">
          {arrData.map((item: any) => (
            <article key={item.id} className="item-card item-card--compact">
              <div className="item-card__icon" style={{ background: '#013951' }}>
                <img src={iconImagen} alt="imagen" style={{ width: 22, height: 22, objectFit: "contain" }} />
              </div>
              <div className="item-card__content">
                <div className="item-card__title">{item.Titulo}</div>
                <div className="item-card__meta">
                  {item.FechaHoraInicio && (
                    <span className="item-card__sub">
                      {Moment(item.FechaHoraInicio).format("DD/MM/YYYY HH:mm")}
                    </span>
                  )}
                  {item.nombreFacultativo && (
                    <span className="item-card__sub">{item.nombreFacultativo}</span>
                  )}
                  {item.centro?.descripcion && (
                    <span className="item-card__sub">{item.centro.descripcion}</span>
                  )}
                </div>
              </div>
              <div className="item-card__action">
                <button
                  className="item-card__download-btn"
                  onClick={() => rowSelected({ data: item })}
                >
                  <Icon name="eye" size={14} />
                  Ver
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
  }
};

export default RecordDetailVisitGrid;
